import React from 'react';

// materiais

import retcri from '../docs/materiais/material-quimica/RetículosCristalinos.pdf';
import procol from '../docs/materiais/material-quimica/Coligativas.pdf';
import inorg from '../docs/materiais/material-quimica/Introdução-à-Química-Orgânica.pdf';
import funinorganica from '../docs/materiais/material-quimica/Funções-Inorgânicas.pdf';
import inter from '../docs/materiais/material-quimica/Introdução_à_Termoquímica.pdf';
import term from '../docs/materiais/material-quimica/Luiz___Energia_Interna_e_Primeira_Lei_da_termodinâmica.pdf';
import decnuclear from '../docs/materiais/material-quimica/Radioatividade_Decaimento_Nuclear.pdf';
import cinetica from '../docs/materiais/material-quimica/Cinética_Química.pdf';
import probcinetica from '../docs/materiais/material-quimica/Problemas_de_Cinética_Química.pdf';

const Quimicamat = () => {
    return (
        <div>
            <h1 className="fontizzao">MATERIAIS - QUÍMICA</h1>
            <hr className="line3"></hr>
            <center>
                <div className="text-container2">
                    <h4 className="corzaoo">
                        Para aprender os principais conteúdos que costumam aparecer em olimpíadas científicas e vestibulares, esta seção é o lugar ideal. Aqui, você encontrará materiais organizados para ajudar a fortalecer sua base de conhecimentos e desenvolver as habilidades necessárias para se destacar. Pronto(a) para alcançar novos patamares?
                    </h4>
                </div>
                <br />
            </center>
            <div className="fundo">
                <center>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Radioatividade: Decaimento Nuclear</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={decnuclear}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Energia e Primeira Lei da Termodinâmica</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={term}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Teoria de Cinética Química</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={cinetica}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Problemas de Cinética Química</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={probcinetica}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Retículos Cristalinos</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={retcri}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Propriedades Coligativas</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={procol}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Funções Inorgânicas</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={funinorganica}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Introdução à Química Orgânica</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={inorg}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Introdução à Termoquímica</h4>
                        <h4 className="cor">
                            OBQ | ITA/IME
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={inter}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                </center>
            </div>
        </div>
    );
}

export default Quimicamat;
